module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousFFView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("CC " + _vm._s(_vm.$route.params.ccType) + " Docs")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("SHIPPER VGM")]), _vm._v(" "), (_vm.vgmUploadView.length > 0) ? _c('div', _vm._l((_vm.vgmUploadView), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(item != '' && item != null) ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/CC_Export_Uploads/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))]) : _c('span', {
      staticClass: "error"
    }, [_vm._v("Document Not Uploaded")])])])
  })) : _c('div', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Document Not Uploaded")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("SHIPPING BILL")]), _vm._v(" "), (_vm.sbUploadView.length > 0) ? _c('div', _vm._l((_vm.sbUploadView), function(item1, index) {
    return _c('div', {
      key: index,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(item1 != '' && item1 != null) ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/CC_Export_Uploads/" + item1,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))]) : _c('span', {
      staticClass: "error"
    }, [_vm._v("Document Not Uploaded")])])])
  })) : _c('div', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Document Not Uploaded")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("DELIVERY ORDER")]), _vm._v(" "), (_vm.doUploadView.length > 0) ? _c('div', _vm._l((_vm.doUploadView), function(item10, index) {
    return _c('div', {
      key: index,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(item10 != '' && item10 != null) ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/CC_Import_Uploads/" + item10,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))]) : _c('span', {
      staticClass: "error"
    }, [_vm._v("Document Not Uploaded")])])])
  })) : _c('div', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Document Not Uploaded")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("APPROVED CHECK LIST")]), _vm._v(" "), (_vm.approveCheckUploadView.length > 0) ? _c('div', _vm._l((_vm.approveCheckUploadView), function(item3, index) {
    return _c('div', {
      key: index,
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [(item3 != '' && item3 != null) ? _c('a', {
      attrs: {
        "href": _vm.docURL + "/CC_Export_Uploads/" + item3,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))]) : _c('span', {
      staticClass: "error"
    }, [_vm._v("Document Not Uploaded")])])])
  })) : _c('div', [_c('span', {
    staticClass: "error"
  }, [_vm._v("Document Not Uploaded")])])])]), _vm._v(" "), (_vm.importEntryPageDoc.length > 0) ? _c('div', {
    staticClass: "row mt-3"
  }, _vm._l((_vm.importEntryPageDoc), function(item4, index) {
    return _c('div', {
      key: index,
      staticClass: "col-md-2"
    }, [_c('label', {
      staticStyle: {
        "text-transform": "uppercase !important"
      }
    }, [_vm._v(_vm._s(item4.trackingDoc))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-12"
    }, [_c('a', {
      staticStyle: {
        "margin-left": "-15px"
      },
      attrs: {
        "href": _vm.docURL + "/CC_Import_Uploads/" + item4.trackDocUpload,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document")])])])
  })) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "alertAddSeaImp",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5eeb7456","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/CCImport/ccDocListPage.vue
// module id = 2670
// module chunks = 0